import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Autoplay } from 'swiper/modules';
import "swiper/css"

export default class extends Controller {
  static values = {
    options: Object
  }

  connect() {
    console.log("Swiper connecting...");
    const defaultOptions = {
      modules: [Autoplay],
      loop: true, // ループ有効
      slidesPerView: 'auto', // 一度に表示する枚数
      speed: 6000, // ループの時間
      spaceBetween: 20, // スライド間のスペース
      autoplay: {
        delay: 0, // 途切れなくループ
        disableOnInteraction: true, // ユーザー操作後も自動再生を継続
      },
      grabCursor: true
    }

    // オプション値が設定されているかチェック
    let options;
    if (this.hasOptionsValue) {
      options = { ...defaultOptions, ...this.optionsValue }
    } else {
      options = defaultOptions;
    }

    console.log("Swiper options:", options);
    this.swiper = new Swiper(this.element, options)
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }
}